import Link from "./Link"
import Image from "./Image"

export default function Networking({ identity, networking }) {
    return (
        <div className="networking">
            <i>
                <Link
                    href="linkedin"
                    target="_blank"
                >
                        <Image 
                            src="linkedin"
                            alt="Téléphone"
                        />
                </Link>
            </i>
            <i>
                <Link
                    href="github"
                    target="_blank"
                    params={ networking && networking.github }
                >
                    <Image
                        src="github"
                        alt="Github"
                    />
                </Link>
            </i>
            <i>
                <Link
                    href="telefon"
                    target="_blank"
                    params={ identity }
                >
                    <Image
                        src="telefon"
                        alt="Téléphone"
                    />
                </Link>
            </i>
            <i>
                <Link
                    href="whatsapp"
                    target="_blank"
                    params={ {identity: identity, message: "Bonjour, je vous contact car votre profile me semble intéressant. Pouvons-nous nous entendre pour discuster d'une éventuelle collaboration ?"} }
                >
                    <Image
                        src="whatsapp"
                        alt="WhatsApp"
                    />
                </Link>
            </i>
        </div>
    )
}